import styled from 'styled-components';
import { TextBold } from '../../styles/GlobalStyledComponents';
import { colors } from '../../styles/Colors';
import { CardInput } from '../CardInputs/CardsStyledComponents';
import { ButtonsWrapper } from '../Button/ButtonStyledComponent';

export const ModalContainer = styled.div`
  width: 600px;
  max-height: 90%;
  position: fixed;
  background-color: ${colors.white};
  /* border: solid 1px gray; */
  z-index: 99;
  top: 5vh;
  left: calc(50% - 300px);
  margin-bottom: 30px;
  overflow-y: auto;
  box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
  border-radius: 24px;
  @media (max-width: 850px) {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
`;
export const ModalSection = styled.div`
  background-color: ${colors.white};
  padding: 0 24px;
  margin-top: 90px;

  @media (max-width: 650px) {
    padding: 0 16px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  position: relative;
  width: 100%;

  @media (max-width: 650px) {
    flex-direction: column;
  }
`;

export const HeaderFixed = styled.div`
  display: flex;
  position: fixed;
  background: white;
  z-index: 99;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 90px;
  padding: 16px 24px;
  width: 100%;
  max-width: 600px;
  border-radius: 16px 16px 0 0;

  @media (max-width: 850px) {
    max-width: 100%;
  }

  @media (max-width: 650px) {
    padding: 16px;
  }
`;

export const TitleBold = styled(TextBold)``;

export const CardTextBold = styled(TextBold)``;

export const IconCloseWrapper = styled.div`
  cursor: pointer;
`;

export const CardInputClickModal = styled(CardInput)`
  flex-direction: column;
  padding: 0px;
  gap: 0px;
`;

export const CardCheckboxSection = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  gap: 8px;
  padding: 10px;
`;

interface CardInputSectionProps {
  $selected?: boolean;
}

export const CardInputSection = styled.div<CardInputSectionProps>`
  background-color: ${colors.gray12};
  border-radius: 0 0 16px 16px;
  padding: ${(props) => (props.$selected ? '12px 16px' : '0px')};
`;

export const PhoneListWrapper = styled.div`
  padding: 0 8px;
`;

export const CallInfoWrapper = styled.div`
  margin: 32px auto;

  @media (max-width: 650px) {
    margin: 16px auto;
  }
`;

export const CallInfo = styled.div`
  background-color: ${colors.gray12};
  border-radius: 12px;
  max-width: 500px;
  padding: 16px;
  margin: 0 auto;
  display: flex;
  gap: 10px;
  line-height: 22px;
`;
export const CallInfoText = styled.div``;

export const PhoneText = styled.a`
  font-size: 16px;
  font-weight: ${(props) => props.theme.fontWeight.textBold};
  color: ${(props) => props.theme.colors.gray0};
  text-decoration: none;
  white-space: nowrap;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 32px;
  position: sticky;
  bottom: 0px;
  background-color: ${colors.white};

  @media (max-width: 650px) {
    padding: 0px;
  }
`;

export const OtherPhoneWrapper = styled.div`
  position: relative;
`;

export const OtherPhoneInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0 10px 0;
  position: relative;
`;

interface OtherPhoneInputProps {
  numberError?: boolean;
}
export const OtherPhoneInput = styled.input<OtherPhoneInputProps>`
  position: relative;
  font-size: 16px;
  margin: 5px 0 0;
  background: ${colors.white};
  border: 1px solid #3330303d;
  box-shadow: inset 0px 3px 0px rgba(0, 0, 0, 0.0298347);
  border-radius: 4px;
  width: 100%;
  height: 48px;
  padding: 10px;
  border-color: ${(props) =>
    props.numberError ? props.theme.colors.red5 : `${colors.lightGray}`};
  cursor: pointer;
  :focus-visible {
    outline: 1px solid ${colors.lightGray};
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

interface DateInputProps {
  dateError?: boolean;
}

export const DateInput = styled(OtherPhoneInput)<DateInputProps>`
  border-color: ${(props) =>
    props.dateError ? props.theme.colors.red5 : `${colors.gray6}`};
  padding-top: 1.2rem;
`;

export const DateTimeInputWrapper = styled(OtherPhoneInputWrapper)`
  width: 100%;
  margin: 4px 0;
  position: relative;
  input.input-error {
    border: 1px solid red;
  }
`;

export const InputLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 0.1rem 0.6rem;
  pointer-events: none;
  border: 1px solid transparent;
  color: ${colors.gray6};
  opacity: 1 !important;

  @media (max-width: 650px) {
    padding-top: 0.4rem;
  }
`;

interface IconPhoneProps {
  select?: boolean;
}

export const IconPhone = styled.span<IconPhoneProps>`
  position: absolute;
  right: 5px;
  top: 20px;
  width: 16px;
  height: 16px;
  background-image: ${(props) =>
    props.select ? "url('./BlackCallIcon.svg')" : "url('./GrayCallIcon.svg')"};
  background-repeat: no-repeat;
`;

export const CallMeButtonsWrapper = styled(ButtonsWrapper)`
  max-width: 100%;
`;
